(function ($) {
  $(document).ready(function ($) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/
    $("*")
      .on("touchstart", function () {
        $(this).trigger("hover");
      })
      .on("touchend", function () {
        $(this).trigger("hover");
      });

    /*****************************************************************
      For when we do a img src="example.svg" SVG use instead of the
      <svg> html markup
    ******************************************************************/
    $("img.svg").each(function () {
      var $img = $(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");
      var dataFill = $img.attr("data-fill-color");
      var dataStroke = $img.attr("data-stroke-color");
      $.get(
        imgURL,
        function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find("svg"),
            $svgElements = $(data).find("svg *");
          // Add replaced image's ID to the new SVG
          if (typeof imgID !== "undefined") {
            $svg = $svg.attr("id", imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== "undefined") {
            $svg = $svg.attr("class", imgClass + " replaced-svg");
          }

          if ($img.parent(".svg-egg").length) {
            $svgElements = $svgElements.removeAttr("stroke");
          }
          // Add Fill color of SVG
          if (typeof dataFill !== "undefined") {
            $svg = $svg.attr("fill", dataFill);
          }

          // Add Stroke color of SVG
          if (typeof dataStroke !== "undefined") {
            $svg = $svg.attr("stroke", dataStroke);
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr("xmlns:a");

          // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
          if (!$svg.attr("viewBox") && $svg.attr("height") && $svg.attr("width")) {
            $svg.attr("viewBox", "0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
          }
          // Replace image with new SVG
          $img.replaceWith($svg);
        },
        "xml"
      );
    });

    /*****************************************************************
      Animation Library / Area.
      GSAP + GSAP ScrollTrigger
    ******************************************************************/
    gsap.registerPlugin(ScrollTrigger);

    // GSAP Custom Parallax
    gsap.utils.toArray("[data-gsap]").forEach((el) => {
      const obj = eval("(" + el.dataset.gsap + ")");
      // Scroll Options
      const scrollProps = {
        scrollTrigger: {
          start: "top bottom",
          end: "bottom top",
          trigger: el,
          scrub: 0.5, // Sets a 0.5 second delay, true is default for scrub
          // markers: true,
        },
      };
      // Add values to object from element data attribute
      Object.assign(scrollProps, obj);

      gsap.to(el, scrollProps);
    });

    // Scroll into view section animations
    gsap.utils.toArray(".fade-in-up").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });

    gsap.utils.toArray(".fade-in").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });

    gsap.utils.toArray(".line-reveal").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });

    gsap.utils.toArray(".scroll-custom").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });
  }); // end .ready()
})(jQuery);
